import { render } from "./WorkDescriptionContainer.vue?vue&type=template&id=372c9e28&scoped=true&ts=true"
import script from "./WorkDescriptionContainer.vue?vue&type=script&lang=ts"
export * from "./WorkDescriptionContainer.vue?vue&type=script&lang=ts"

import "./WorkDescriptionContainer.vue?vue&type=style&index=0&id=372c9e28&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-372c9e28"]])

export default __exports__